import { User } from "../types";

type LogOut = {
    success?: boolean,
    erors?: [{
        message: string
    }],
};

export default async function logout(): Promise<LogOut> {
    try {
        const req = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/user/logout`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
        });
        const data = await req.json();
        return data;
    } catch (err) {
        return err;
    }
}